import React, { useEffect } from 'react';
import { Switch, useHistory } from 'react-router-dom';
import Route from './Route';
import SignIn from '../pages/Auth/SignIn/index';
import SignUp from '../pages/Auth/SignUp/index';
import ForgotPassword from '../pages/Auth/ForgotPassword/index';
import RecoverPassword from '../pages/Auth/RecoverPassword/index';
import Main from '../pages/Main/index';
import Invites from '../pages/Invite/index';
import CreateGroup from '../pages/Groups/Create/index';
import SearchGroup from '../pages/Groups/Search/index';
import GroupDetails from '../pages/Groups/Details/index';
import ListGroups from '../pages/Groups/List/index';
import ContactInfo from '../pages/Profile/ContactInfo/index';
import ChangePassword from '../pages/Profile/ChangePassword/index';
import ChangeEmail from '../pages/Profile/ChangeEmail/index';
import ConfirmEmail from '../pages/Email';
import ResendEmail from '../pages/ResendEmail';
import ResendEmailSignUp from '../pages/ResendEmail/signup';
import Resources from '../pages/Resources/index';
import ReactGA from 'react-ga';

import api from './../services/api';
import { useAuth } from '../Context/Auth/AuthContext';

export default function Routes() {
    const history = useHistory();
    const { logout } = useAuth();

    // Error handler
    api.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            if (error) {
                switch (error.response.status) {
                    case 401:
                        logout();
                        localStorage.removeItem('@Reachout:user');
                        localStorage.removeItem('@Reachout:groupRole');
                        history.push('/');
                        break;
                    case 502:
                        logout();
                        localStorage.removeItem('@Reachout:user');
                        localStorage.removeItem('@Reachout:groupRole');
                        history.push('/');
                        break;
                    case 503:
                        logout();
                        localStorage.removeItem('@Reachout:user');
                        localStorage.removeItem('@Reachout:groupRole');
                        history.push('/');
                        break;
                    default:
                        break;
                }
            }

            return Promise.reject(error);
        }
    );

    useEffect(() => {
        const enabledGA = process.env.REACT_APP_GOOGLE_ANALYTICS_ENABLED;
        if (enabledGA === 'true') {
            ReactGA.set({ page: window.location.pathname });
            ReactGA.pageview(window.location.pathname);
        }
    }, []);

    return (
        <Switch>
            <Route path="/" exact component={SignIn} />
            <Route path="/signup/:role?" exact component={SignUp} />
            <Route path="/forgot-password" exact component={ForgotPassword} />
            <Route path="/recover-password" exact component={RecoverPassword} />
            <Route path="/main" isPrivate exact component={Main} />
            <Route path="/resources" isPrivate exact component={Resources} />
            <Route
                path="/group/create"
                isPrivate
                exact
                component={CreateGroup}
            />
            <Route
                path="/group/search"
                isPrivate
                exact
                component={SearchGroup}
            />
            <Route path="/groups" isPrivate exact component={ListGroups} />
            <Route path="/group/:id" isPrivate exact component={GroupDetails} />
            <Route path="/invite/:token" isInvite exact component={Invites} />
            <Route path="/confirm/:email" isInvite exact component={ResendEmail} />
            <Route path="/confirm-signup/:email" isInvite exact component={ResendEmailSignUp} />
            <Route
                path="/confirm-email/:token"
                isInvite
                exact
                component={ConfirmEmail}
            />
            <Route
                path="/profile/contact-info"
                isPrivate
                exact
                component={ContactInfo}
            />
            <Route
                path="/profile/change-password"
                isPrivate
                exact
                component={ChangePassword}
            />
            <Route
                path="/profile/change-email"
                isPrivate
                exact
                component={ChangeEmail}
            />
        </Switch>
    );
}
